export const SET_IS_FETCHING = 'dashboard/Notification/SET_IS_FETCHING'
export const SET_IS_FETCHING_MARK_READ = 'dashboard/Notification/SET_IS_FETCHING_MARK_READ'
export const MESSAGES_RECEIVED = 'dashboard/Notification/MESSAGES_RECEIVED'
export const SET_MESSAGES_PAGING = 'dashboard/Notification/SET_MESSAGES_PAGING'
export const SET_USER_ROLES_TO_SW = 'dashboard/Notification/SET_USER_ROLES_TO_SW'
export const SET_QUERY_FILTER = 'dashboard/Notification/SET_QUERY_FILTER'
